import styled from "styled-components";
import { typography, palette, spacing } from "@conserveit/blocks";

export const InlineAction = styled.button.attrs({ type: "button" })`
  display: inline-block;
  border: 0;
  background: transparent;
  margin: 0;
  padding: ${spacing.extraTight} ${spacing.tight};

  ${typography.bodySmall}
  color: ${palette.blue7};
`;

export const ListSection = styled.div`
  margin-bottom: ${spacing.snug};
  padding: 0 ${spacing.extraTight};
  padding-bottom: ${spacing.extraTight};
`;

export const NoResultsText = styled.p`
  ${typography.body}
`;

export const ListWrap = styled.div``;
